import {Fragment} from "react";
import TopBar from "../TopBar";
import Navbar from "../Navbar";
import ContactUs from "../ContactUs";
import Footer from "../Footer";
import AboutUs from "../AboutUs";

const ContactPage = () =>{
    return (
        <Fragment>
            <TopBar></TopBar>
            <Navbar></Navbar>
            <ContactUs></ContactUs>
            <Footer></Footer>
        </Fragment>
    )
}

export default ContactPage;